import { render, staticRenderFns } from "./IndagineEpidemiologicaInfezioniAlimentariViewComponent.vue?vue&type=template&id=095254f4"
import script from "./IndagineEpidemiologicaInfezioniAlimentariViewComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaInfezioniAlimentariViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports